var mentions_default = {
  "mentionPalette": "HAYCD",
  "mention": "LiE7J",
  "mentionViewer": "meZSO",
  "mentionSuggestionsEntry": "O4bAq",
  "mentionSuggestionsEntryFocused": "ATT4-",
  "mentionSuggestionsEntryText": "snXI3",
  "mentionSuggestionsEntryAvatar": "nVBpw",
  "mentionSuggestions": "sfWUb",
  "cursorDefault": "Mk3ps",
  "cursorPointer": "f8skB"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
